import { Controller } from "stimulus";
import Sortable from "sortablejs";
import { patch } from "@rails/request.js";

// Drag-to-reorder for the course content topics. The grip handle starts the drag; on drop we PATCH
// the new id order and the server re-renders the list (refreshing the order numbers).
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-reorder-handle]",
      draggable: "tr[data-id]",
      animation: 150,
      ghostClass: "opacity-40",
      onEnd: this.persist.bind(this),
    });
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy();
  }

  async persist(event) {
    if (event.oldIndex === event.newIndex) return;

    const ids = Array.from(this.element.querySelectorAll("tr[data-id]")).map((row) => row.dataset.id);
    await patch(this.urlValue, {
      body: JSON.stringify({ ids }),
      contentType: "application/json",
      responseKind: "turbo-stream",
    });
  }
}
